export default __webpack_public_path__ + "static/media/email.661d9a6d.svg";